// extracted by mini-css-extract-plugin
export default {"address":"adc__address--YW1wD"};